import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import Logger from "@cappelendamm/logger";
import { getBookFromProductVariant } from "../../product/selectors/getBookFromProductVariant.js";
const SERIES_DEFINITION_IDS = CRYSTALLIZE_IDS.SHAPE.DOCUMENT.SERIES_DEFINITION;
export const getSubscriptionSeriesDefinition = (subscription) => {
    const seriesDefinitionItem = getSeriesDefinitionItem(subscription);
    return {
        name: seriesDefinitionItem.name,
        status: getSeriesDefinitionStatus(seriesDefinitionItem),
        products: getSeriesDefinitionBooks(seriesDefinitionItem),
    };
};
function getSeriesDefinitionItem(subscription) {
    const seriesDefinitionContent = getComponentContentById(subscription.product.components, SERIES_DEFINITION_IDS.ID);
    if (!seriesDefinitionContent) {
        throw new Error(`Series subscription is missing series definition component (id: ${SERIES_DEFINITION_IDS.ID}. Subscription name: ${subscription.name}`);
    }
    if (!seriesDefinitionContent?.items?.length) {
        throw new Error(`Series subscription has no set series definition. Subscription name: ${subscription.name}`);
    }
    return seriesDefinitionContent.items[0];
}
function getSeriesDefinitionStatus(seriesDefinitionItem) {
    const seriesStatusContent = getComponentContentById(seriesDefinitionItem.components, SERIES_DEFINITION_IDS.SERIES_STATUS);
    if (!seriesStatusContent?.options?.length) {
        throw new Error(`Series definition is missing status. Series definition name: ${seriesDefinitionItem.name}`);
    }
    return seriesStatusContent.options[0]?.key;
}
function getSeriesDefinitionBooks(seriesDefinitionItem) {
    const seriesBooksContent = getComponentContentById(seriesDefinitionItem.components, SERIES_DEFINITION_IDS.BOOKS.ID);
    if (!seriesBooksContent) {
        Logger.warn(`Series definition has no books. Series definition name: ${seriesDefinitionItem.name}`);
        return [];
    }
    return getBookChunkItems(seriesBooksContent);
}
const getBookChunkItems = (seriesBooksContent) => {
    const { chunks } = seriesBooksContent;
    if (!chunks)
        return [];
    const allBooks = [];
    for (const chunkComponents of chunks) {
        const chunkNumberInSeries = getComponentContentById(chunkComponents, SERIES_DEFINITION_IDS.BOOKS.NUMBER_IN_SERIES)?.number;
        const itemRelationsContent = getComponentContentById(chunkComponents, SERIES_DEFINITION_IDS.BOOKS.BOOK);
        if (!itemRelationsContent?.productVariants?.length) {
            continue;
        }
        // Assume there is one and only one product variant per chunk
        const variant = itemRelationsContent.productVariants[0];
        if (!variant) {
            continue;
        }
        const book = getBookFromProductVariant(variant);
        // If number in series is defined in chunk, override the one from product component
        if (chunkNumberInSeries !== undefined) {
            book.numberInSeries = chunkNumberInSeries;
        }
        allBooks.push(book);
    }
    return allBooks;
};
